import React from 'react';
import memoize from 'memoize-one';
import { ButtonTooltip, Icon } from '../../index';

const TalentSurveyColumns = memoize(clickHandler => [
  {
    name: 'ENCUESTA',
    selector: 'survey',
    cell: item => item.survey?.label || item.surveyName,
    sortable: true,
    grow: '5'
  },
  {
    name: 'Estado',
    selector: 'status',
    cell: item => item.translatedStatus || (item.status === 'answered' ? 'Completada' : 'Pendiente'),
    sortable: true,
    grow: '2'
  },
  {
    name: 'ACCIONES',
    cell: item => {
      const isAnonymous = item.isAnonymous || item.survey?.isAnonymous;
      return (
        <ButtonTooltip
          onClick={() => clickHandler(item, 'view')}
          variant="circle-primary"
          className="btn-circle"
          size="sm"
          text="Ver"
          disabled={item.status !== 'answered' || isAnonymous}
        >
          <Icon icon="eye" />
        </ButtonTooltip>
      );
    },
    ignoreRowClick: true,
    grow: '1',
    center: true
  }
]);

export default TalentSurveyColumns;
